angular.module('tf.models')


    .factory("Project",['UrlEncodingService','ThumbnailSequence', '$q', 'FileParsingService', 'Template','Session',
        function(UrlEncodingService, ThumbnailSequence, $q, FileParsingService, Template, Session) {


            var project = function Project(data) {
                this.loadData(data);
            };

            var comparableFields = ['value', 'size', 'crop', 'isCrop', 'lockAspect'];

            function formatDate(date, format, utc) {
                var MMMM = ["\x00", "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
                var MMM = ["\x01", "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
                var dddd = ["\x02", "Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
                var ddd = ["\x03", "Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

                function ii(i, len) {
                    var s = i + "";
                    len = len || 2;
                    while (s.length < len) s = "0" + s;
                    return s;
                }

                var y = utc ? date.getUTCFullYear() : date.getFullYear();
                format = format.replace(/(^|[^\\])yyyy+/g, "$1" + y);
                format = format.replace(/(^|[^\\])yy/g, "$1" + y.toString().substr(2, 2));
                format = format.replace(/(^|[^\\])y/g, "$1" + y);

                var M = (utc ? date.getUTCMonth() : date.getMonth()) + 1;
                format = format.replace(/(^|[^\\])MMMM+/g, "$1" + MMMM[0]);
                format = format.replace(/(^|[^\\])MMM/g, "$1" + MMM[0]);
                format = format.replace(/(^|[^\\])MM/g, "$1" + ii(M));
                format = format.replace(/(^|[^\\])M/g, "$1" + M);

                var d = utc ? date.getUTCDate() : date.getDate();
                format = format.replace(/(^|[^\\])dddd+/g, "$1" + dddd[0]);
                format = format.replace(/(^|[^\\])ddd/g, "$1" + ddd[0]);
                format = format.replace(/(^|[^\\])dd/g, "$1" + ii(d));
                format = format.replace(/(^|[^\\])d/g, "$1" + d);

                var H = utc ? date.getUTCHours() : date.getHours();
                format = format.replace(/(^|[^\\])HH+/g, "$1" + ii(H));
                format = format.replace(/(^|[^\\])H/g, "$1" + H);

                var h = H > 12 ? H - 12 : H === 0 ? 12 : H;
                format = format.replace(/(^|[^\\])hh+/g, "$1" + ii(h));
                format = format.replace(/(^|[^\\])h/g, "$1" + h);

                var m = utc ? date.getUTCMinutes() : date.getMinutes();
                format = format.replace(/(^|[^\\])mm+/g, "$1" + ii(m));
                format = format.replace(/(^|[^\\])m/g, "$1" + m);

                var s = utc ? date.getUTCSeconds() : date.getSeconds();
                format = format.replace(/(^|[^\\])ss+/g, "$1" + ii(s));
                format = format.replace(/(^|[^\\])s/g, "$1" + s);

                var f = utc ? date.getUTCMilliseconds() : date.getMilliseconds();
                format = format.replace(/(^|[^\\])fff+/g, "$1" + ii(f, 3));
                f = Math.round(f / 10);
                format = format.replace(/(^|[^\\])ff/g, "$1" + ii(f));
                f = Math.round(f / 10);
                format = format.replace(/(^|[^\\])f/g, "$1" + f);

                var T = H < 12 ? "AM" : "PM";
                format = format.replace(/(^|[^\\])TT+/g, "$1" + T);
                format = format.replace(/(^|[^\\])T/g, "$1" + T.charAt(0));

                var t = T.toLowerCase();
                format = format.replace(/(^|[^\\])tt+/g, "$1" + t);
                format = format.replace(/(^|[^\\])t/g, "$1" + t.charAt(0));

                var tz = -date.getTimezoneOffset();
                var K = utc || !tz ? "Z" : tz > 0 ? "+" : "-";
                if (!utc) {
                    tz = Math.abs(tz);
                    var tzHrs = Math.floor(tz / 60);
                    var tzMin = tz % 60;
                    K += ii(tzHrs) + ":" + ii(tzMin);
                }
                format = format.replace(/(^|[^\\])K/g, "$1" + K);

                var day = (utc ? date.getUTCDay() : date.getDay()) + 1;
                format = format.replace(new RegExp(dddd[0], "g"), dddd[day]);
                format = format.replace(new RegExp(ddd[0], "g"), ddd[day]);

                format = format.replace(new RegExp(MMMM[0], "g"), MMMM[M]);
                format = format.replace(new RegExp(MMM[0], "g"), MMM[M]);

                format = format.replace(/\\(.)/g, "$1");

                return format;
            }

            function setValue(control, value){
                if(value && value.toLowerCase && control.ui && control.ui.type && control.ui.type === 'checkbox'){
                    control.value = (value.toLowerCase() === 'true' || value === '1');
                } else {
                    control.value = value;
                }
            }

            project.prototype = {
                loadData: function (data) {
                    angular.extend(this, data);
                    for (var i = 0; i < this.templates.length; i++) {
                        this.templates[i] = new Template(this.templates[i]);
                    }
                },
                getId: function () {
                    return this.id;
                },
                getName: function () {
                    if (this.settings && this.settings.useProjectCustomFormat) {

                        var baseName = this.settings.projectCustomFormat || '';
                        var arr;

                        //Find Fields
                        var re = RegExp('\\[\\[(.*?)\\]\\]', 'g');

                        while ((arr = re.exec(this.settings.projectCustomFormat)) !== null) {
                            //baseName = baseName.replace(arr[0], moment().format(arr[1]));
                            baseName = baseName.replace(arr[0],formatDate( new Date(),arr[1]));
                        }

                        //Static Values
                        baseName = baseName.replace('||ProjectName||', this.name);

                        baseName = baseName.replace('||UserName||', Session.user.local.username);
                        baseName = baseName.replace('||FirstName||', Session.user.local.first_name);
                        baseName = baseName.replace('||FirstNameInit||', Session.user.local.first_name[0]);
                        baseName = baseName.replace('||LastName||', Session.user.local.last_name);
                        baseName = baseName.replace('||LastNameInit||', Session.user.local.last_name[0]);


                        return baseName;
                    } else {
                        return this.name;
                    }
                },
                isProjectRename: function () {
                    return this.projectRename || false;
                },
                getLocation: function () {
                    return this.location;
                },
                isTemplatesReorder: function () {
                    return this.templatesReorder || false;
                },
                isTemplatesRename: function () {
                    return this.templatesRename || false;
                },
                isTemplatesDuplicate: function () {
                    return this.templatesDuplicate || false;
                },
                isDuplicates: function () {
                    return this.duplicates || false;
                },
                getTemplates: function () {
                    return this.templates;
                },
                getTemplateByName: function (name) {
                    for (var i = 0; i < this.templates.length; i++) {
                        var template = this.templates[i];
                        if (template.originalName === name) {
                            return template;
                        }
                    }
                },
                getTemplateIndex: function (template) {
                    return this.getTemplates().indexOf(template);
                },
                clean: function () {
                    var copy = angular.copy(this);
                    for (var i = 0; i < copy.templates.length; i++) {
                        copy.templates[i] = copy.templates[i].clean();
                        try {
                            copy.templates[i].customName = copy.templates[i].getName();
                        } catch (e) {}
                    }
                    return copy;
                },
                getComparableFields: function () {
                    return comparableFields;
                },
                isAllowedMimeType: FileParsingService.isSheetFile,

                populateControls: function (template, file) {
                    if (_.isNumber(template) && this.templates.length > template) {
                        template = this.templates[template];
                    }
                    var defer = $q.defer();
                    FileParsingService.parseSheet(file).then(function (data) {

                        var headers = data.shift();

                        _.each(headers, function (header, column) {
                            _.chain(template.controls)
                                .filter(function (control) {
                                    return control.name.toLowerCase().startsWith(header.toLowerCase().trim());
                                })
                                .sortBy('name')
                                .each(function (control, row) {
                                    var value = '';
                                    try {
                                        value = data[row][column];
                                    } catch (err) {
                                    }
                                    setValue(control, value);
                                })
                                .value();
                        });

                        defer.resolve();
                    });
                    return defer.promise;
                },
                populateTemplates: function (template, file) {
                    if (!template.settings || (template.settings && !template.settings.duplicate)) {
                        return this.populateControls(template, file);
                    }
                    if (_.isNumber(template) && this.templates.length > template) {
                        template = this.templates[template];
                    }
                    var defer = $q.defer();
                    var self = this;
                    FileParsingService.parseSheet(file).then(function (data) {

                        if (template.checkControlMatch(data[0])) {

                            var headers = data.shift();

                            var duplicates = [];

                            _.each(data, function (row, index) {
                                var duplicateTemplate;
                                if (index === 0) {
                                    duplicateTemplate = template;
                                } else {
                                    duplicateTemplate = new Template(template.duplicate());
                                    duplicates.push(duplicateTemplate);
                                }
                                _.each(row, function (value, index) {
                                    _.chain(duplicateTemplate.controls)
                                        .filter(function (control) {
                                            return control.name.toLowerCase().trim() === headers[index].toLowerCase().trim();
                                        })
                                        .each(function (control) {
                                            setValue(control, value);
                                        })
                                        .value();
                                });
                            });
                            self.templates.splice.apply(self.templates, [self.templates.indexOf(template) + 1, 0].concat(duplicates));
                        }
                        defer.resolve();
                    });

                    return defer.promise;


                }
            };

            return project;

        }]);
